// extracted by mini-css-extract-plugin
export default {"grid-container":"Category_grid-container__riiWt","category-filter":"Category_category-filter__grR65","product":"Category_product__QqiZ8"};